<template>
	<v-layout row wrap white info--text class="section-faq" id="question">
		<div class="container">
			<v-layout wrap>
				<v-flex xs3 sm2 md1>
					<img src="/static/images/icons/favicon-casamarket.svg" alt="mi bodega" height="58">
				</v-flex>
				<v-flex xs9 sm10 md11>
					<h2 class="section-faq-title secondary--text">PREGUNTAS FRECUENTES</h2>
				</v-flex>
				<v-flex xs12 class="section-faq-container">
					<v-layout row wrap class="section-faq-item">
						<v-flex xs12 md4>
							<v-layout row wrap>
								<v-flex xs12 class="section-faq-item-title">
									¿Cuál es el costo de tener mi propio Aplicativo?		
								</v-flex>
								<v-flex xs12 class="section-faq-item-text">
									Ten tu propia app de pedidos con una mínima inversión. Déjanos tus datos
									<button class="btn-link" @click="$emit('open-register')">aquí</button> para que un asesor de ventas
									se comunique contigo y pueda darte todo el detalle del servicio.
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 md8 class="section-faq-right">
							<v-layout row wrap>
								<v-flex xs12 class="section-faq-item-title">
									¿Qué puedo vender con CasaMarket?		
								</v-flex>
								<v-flex xs12 class="section-faq-item-text">
									Puedes vender lo que quieras en el rubro que desees, recuerda que es tu negocio y hemos creado un aplicativo que se adapta a ti.
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
					<v-layout row wrap class="section-faq-item">
						<v-flex xs12 md4>
							<v-layout row wrap>
								<v-flex xs12 class="section-faq-item-title">
									¿El servicio es a nivel nacional?		
								</v-flex>
								<v-flex xs12 class="section-faq-item-text">
									Si, puedes contratar nuestro servicio a nivel nacional.
									CasaMarket funciona en todo el país.
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 md8 class="section-faq-right">
							<v-layout row wrap>
								<v-flex xs12 class="section-faq-item-title">
									¿Qué pasa si no cuente con el servicio de delivery?	
								</v-flex>
								<v-flex xs12 class="section-faq-item-text">
									No hay problema, CasaMarket se adapta a tu negocio y 
									solo ofrecerás el servicio de "recojo en tienda". 
									En el momento que decidas incluir el servicio de delivery 
									lo incluiremos en tu aplicativo, ya que estamos 
									preparados para ofrecerlo.
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
					<v-layout row wrap class="section-faq-item">
						<v-flex xs12 md4>
							<v-layout row wrap>
								<v-flex xs12 class="section-faq-item-title">
									¿Qué pasa si tengo más de un local?
								</v-flex>
								<v-flex xs12 class="section-faq-item-text">
									Excelente, con CasaMarket puedes gestionar todas las tiendas 
									que tengas. Déjanos tus datos <button class="btn-link" @click="$emit('open-register')">aquí</button> 
									para que un asesor de ventas se comunique contigo y pueda darte todo el detalle del servicio.
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 md8 class="section-faq-right">
							<v-layout row wrap>
								<v-flex xs12 class="section-faq-item-title">
									¿Qué pasa si no cuento con el servicio de pago online?
								</v-flex>
								<v-flex xs12 class="section-faq-item-text">
									No hay problema, CasaMarket se adapta a tu negocio y 
									solo ofrecerás el servicio de "pago en efectivo". 
									En el momento que decidas incluir el servicio de pago online 
									lo incluimos en tu aplicativo, ya que estamos preparados 
									para ofrecerlo. El contrato con las plataformas de pago 
									online es directamente con el dueño cada negocio.
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
					<v-layout row wrap class="section-faq-item">
						<v-flex xs12 md4>
							<v-layout row wrap>
								<v-flex xs12 class="section-faq-item-title">
									¿En cuánto tiempo me entregan el aplicativo?
								</v-flex>
								<v-flex xs12 class="section-faq-item-text">
									Depende cuán rápido efectúes el pago y coordinemos toda la información de tu negocio,
									pero es un promedio de 2 semanas como máximo.
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 md8 class="section-faq-right">
							<v-layout row wrap>
								<v-flex xs12 class="section-faq-item-title">
									¿Cómo funcionan los Pedicréditos?
								</v-flex>
								<v-flex xs12 class="section-faq-item-text">
									Es muy sencillo y hemos pensado la manera más conveniente para tu negocio.
									Sólo debes precargar tu aplicativo con el monto que deseas y éste se
									descontará de cada pedido generado. Por ejemplo, si recargas S/1 de "Pedicréditos"
									ese dinero te alcanza para la comisión de 5 pedidos de S/0.2 {{ money }} cada uno.
									En el caso que no hayas hecho la recarga de "Pedicréditos" y un cliente haga un pedido,
									te avisamos para que recargues y no pierdas la venta. El monto mínimo de recarga es de S/20.
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
					<v-layout row wrap class="section-faq-item">
						<v-flex xs12 md4>
							<v-layout row wrap>
								<v-flex xs12 class="section-faq-item-title">
									¿Quién determina el precio del producto?
								</v-flex>
								<v-flex xs12 class="section-faq-item-text">
									Tú, como dueño de tu negocio. Es muy sencillo de hacerlo:
									Solo ingresas a tu administrador y podrás determinar los precios
									de tus productos.
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 md8 class="section-faq-right">
							<v-layout row wrap>
								<v-flex xs12 class="section-faq-item-title">
									¿CasaMarket trabaja con otro tipo de negocios, como restaurantes o lavanderías?
								</v-flex>
								<v-flex xs12 class="section-faq-item-text">
									Sí, ponemos a disposición de otras industrias el aplicativo para que puedan hacer
									crecer su negocio. En caso desees más información, déjanos tus datos <button class="btn-link" @click="$emit('open-register')">aquí</button> para que
									un asesor de ventas se comunique contigo y pueda darte todo el detalle del servicio.
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</div>
	</v-layout>
</template>

<script>
	function money() {
		return this.code === 'PE' ? 'céntimos' : 'centavos';
	}

	export default {
		name: 'section-faq',
		computed: {
			money,
		},
		props: {
			landingLink: [String],
			code: String,
		},
	};
</script>

<style lang="scss" scoped>
	.section-faq {
		padding: 50px 10% 66px;
		text-align: center;

		@media (min-width: 1024px) {
			text-align: left;
		}

		&-title {
			font-size: size(large30);
			font-weight: weight(w900);
			margin-bottom: 64px;
		}

		&-item {
			&-title {
				background-color: color(background);
				color: color(secondary);
				font-size: size(medium13);
				font-weight: weight(w600);
				padding: 8px 13px;
				margin-bottom: 15px;

				@media (min-width: 1024px) {
					font-size: size(medium16);
				}
			}

			&-text {
				margin-bottom: 15px;
				padding: 8px 13px;
			}
		}

		&-right {
			@media (min-width: 1024px) {
				padding-left: 8%;
			}
		}

		.btn-link {
			border-bottom: 1px solid color(primary);
			color: color(primary);
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-faq.vue